module.exports = __webpack_public_path__ + "img/endorpina.559a00ff.png";